import * as React from "react";
import "./styles/GenericTextButton.scss";
import { t } from "../i18n";

interface Props {
    onClick: () => void;
    title: string;
    style?: any;
    classname?: string;
    beforeAndAfterLocales?: string[];
}


const GenericTextButton: React.FC<Props> = ({ onClick, title, style, classname, beforeAndAfterLocales }) => {
    return (
        <div className={`generic-text-button-container ${classname && classname}`}>
            {beforeAndAfterLocales && beforeAndAfterLocales[0] && t(beforeAndAfterLocales[0]) && <span className="before-generic-text">{t(beforeAndAfterLocales[0])}</span>}
            <span style={style} onClick={onClick} className={"text"}>{t(title)}</span>
            {beforeAndAfterLocales && beforeAndAfterLocales[1] && t(beforeAndAfterLocales[1])  && <span className="after-generic-text">{t(beforeAndAfterLocales[1])}</span>}
        </div>
    )
}

export default GenericTextButton;